import styled from 'styled-components';

const CenteredForm = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-flow: wrap;
  width: 100%;
`;

export default CenteredForm;
